import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { sendAnalyticsInfo } from 'features/analytics/helpers';
import { useAppDispatch } from 'features/app/hooks';
import type { ButtonProps } from 'features/ui/elements';
import { Button } from 'features/ui/elements';

export type ButtonType =
  | 'deaf'
  | 'hearing'
  | 'vco2line'
  | 'conference participant'
  | 'deaf signmail';

export const CallDetailsButtonDisconnect: FC<
  Pick<ButtonProps, 'onClick' | 'loading' | 'hotkey' | 'disabled' | 'sx'> & {
    buttonType?: ButtonType;
  }
> = ({ loading, onClick, hotkey, disabled, sx, buttonType }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const typeOfButton = buttonType ?? 'untyped disconnect';

  const handleClick = async () => {
    dispatch(
      sendAnalyticsInfo({
        Event: 'ButtonClick',
        Method: 'handleDisconnectButtonClick',
        Message: `Click on ${typeOfButton} disconnect button`,
      })
    );

    // Call the original onClick handler
    if (onClick) {
      await onClick();
    }
  };

  return (
    <Button
      data-testid='call-details-disconnect-button'
      fullWidth
      size='small'
      color='error'
      loading={loading}
      disabled={disabled}
      onClick={handleClick}
      hotkey={hotkey}
      sx={sx}
      isSendAnalytics={false}
    >
      {t('disconnect')}
    </Button>
  );
};
